// DS: C41
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import { useChildrenFolding } from '@wix/da-hooks/pkg/useChildrenFolding';
import TagList from '../TagList';
import Tag from '../Tag';
import s from './FoldableTagList.scss';
const MAX_LINES = 2;
const TAG_SPACING = parseInt(s['tag-spacing'], 10);
const TOGGLE_BUTTON_WIDTH = parseInt(s['more-button-width'], 10);
/** A TagList that includes a final, tag-like toggle button that
 *  folds or expands the list from 2 lines to as many as needed. */ export const FoldableTagList = ({ tags , className , isFoldable =true ,  })=>{
    const { t  } = useTranslation();
    const [isFolded, setIsFolded] = useState(isFoldable);
    const { sizedItems , hasHidden , containerRef  } = useChildrenFolding(tags, {
        maxLines: MAX_LINES,
        itemSpacing: TAG_SPACING,
        endPadding: TOGGLE_BUTTON_WIDTH,
        getItemKey: (tag)=>tag.name,
        excludeChild: (element)=>element.classList.contains(s['more-or-less'])
    });
    const sizedTags = useMemo(()=>sizedItems.map(({ item , isOverflow  })=>({
                tagname: item.name,
                href: item.url,
                className: isFoldable && isFolded && isOverflow ? s['overflowed'] : undefined,
                biData: BiData({
                    evid: 391,
                    tag_text: item.name,
                    link_url: item.url
                })
            })), [
        sizedItems,
        isFoldable,
        isFolded
    ]);
    return /*#__PURE__*/ React.createElement(TagList, {
        className: className,
        tags: sizedTags,
        size: "medium",
        isTruncated: true,
        multiline: true,
        ref: containerRef
    }, isFoldable && hasHidden && /*#__PURE__*/ React.createElement(Tag, {
        /* no collision bc hyphens aren't accepted in tag creation */ key: "more-or-less",
        className: s['more-or-less'],
        size: "medium",
        onClick: ()=>setIsFolded(!isFolded),
        biData: BiData({
            evid: 2,
            click_info: isFolded ? 'more' : 'less'
        })
    }, t(isFolded ? 'common.more' : 'common.less')));
};
FoldableTagList.displayName = 'FoldableTagList';
export default FoldableTagList;
